import { ElfsightWidget } from "./ElfsightWidget";

export const Avis = () => {
    return (
        <section>
            <h2 className='text-center font-bold text-4xl text-accent mb-3 ml-2 py-8'><b>Nos</b> avis <i>clients</i></h2>
            <ElfsightWidget />
        </section>
    )
}